import {cs}             from "../react/chain-services";
import {consumeContext} from "../react/context";

import {getCountryCode} from "./template-options/get-country-code";

export const enableCanadaMailing = ({templateOptions, next}) => cs(
    consumeContext("company"),
    consumeContext("session"),
    ["countryCode", (_, next) => next(getCountryCode({templateOptions}))],
    ({company, session, countryCode}) => next(
        ((templateOptions?.product?.idProduct === 488 || templateOptions?.product?.idProduct === 489) &&
        countryCode === 'CA' &&
        (company?.prefs?.enableCanadaMailing || session.data?.branch?.enableCanadaMailing))
    ),
);
